import { Method } from 'axios';

export type IFilter = [string, string];
export type IQuery = [string, any];
export type IPage = [string, number];
export type IInclude = string;
export type IField = [string, string];
export type ISort = string;
export type IRecurringID = string;

export enum EBuildParamTypes {
  QUERIES = 'queries',
  FILTERS = 'filters',
  PAGES = 'pages',
  INCLUDES = 'includes',
  FIELDS = 'fields',
  SORTS = 'sorts',
  RECURRING_ID = 'recurringID',
}

export interface IHttpRequest {
  data?: object;
  headers?: { [key: string]: string };
  method?: Method;
  url: string;
}

export interface IHttpResponse<T = any> {
  status?: number;
  body?: T;
  ok?: boolean;
  message?: string;
  detail?: any;
  errors?: APIError[];
  headers?: Record<string, string>;
}

export interface IHttpErrorResponse {
  status?: number;
  ok: false;
  message?: string;
  detail?: any;
  errors?: APIError[];
  headers?: Record<string, string>;
}

export interface APIError {
  code?: string;
  detail?: string;
  source?: {
    pointer?: string;
    parameter?: string;
  };
}
